module.exports = __webpack_public_path__ + "img/i_share.84fba781.svg";